
import mainSections from "../json/mainsections.json"
import "bootstrap-icons/font/bootstrap-icons.css"
import { useEffect, useState } from "react"
import "../css/Image_Slider.css"
import "../css/Main.css"
import { Link } from "react-router-dom"
import clients from "../json/clients.json"

const Main = () => {

    const slideshowImagesArray = ["slider-1.webp", "slider-2.webp"]
    const [slideshowImage, setSlideshowImage] = useState(slideshowImagesArray[0])

    useEffect(() => {
        const interval = setInterval(() => {
            changeSlideshowImage("right")
        }, 5000)
        return () => clearInterval(interval)
    }, [])



    function changeSlideshowImage(direction) {

        if (direction !== "left" && direction !== "right") return

        setSlideshowImage(prevImage => {
            const index = slideshowImagesArray.indexOf(prevImage)
            const length = slideshowImagesArray.length

            if (index === 0 && direction === "left") {
                return slideshowImagesArray[length - 1]
            }

            if (index === length - 1 && direction === "right") {
                return slideshowImagesArray[0]
            }
            return slideshowImagesArray[direction === "left" ? index - 1 : index + 1]
        })
    }


    return (
        <main className="h100 w100 mar-10">

            <section className="flex sevenly acenter bc-0f pad-10b main-slideshow">
                <i className="bi bi-caret-left-fill white-icon" onClick={() => changeSlideshowImage("left")}></i>
                <img className="main-slideshow-image" alt={slideshowImage} src={"/images/" + slideshowImage} />
                <i className="bi bi-caret-right-fill white-icon" onClick={() => changeSlideshowImage("right")}></i>
            </section>

            <section className="flex acenter col">

                <h2 className="jscenter cspica">Servicios</h2>

                {/* <article className="acenter jcenter pad-10 christmas" >
                    <img className="w100 " alt="Feliz Navidad" src={"/images/felicitacion2.png"} />
                </article> */}

                <div className="flex acenter jcenter gap-50 wrap pad-bottom">

                    {mainSections.map(section => {
                        return (
                            <article className="main-section-container" key={section.id}>

                                <img className="w100 main-section-image" alt={section.title} src={"/images/" + section.image} ></img>
                                <div className="flex col pad-10 main-section-content">
                                    <h3 className="cspica ascenter">{section.title}</h3>
                                    <ul className="main-ul">
                                        {
                                            section.items.map(item => {
                                                return (
                                                    <li key={item.id}>
                                                        {item.description}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </article>
                        )
                    })
                    }

                </div>
            </section>

            {/* <section className="flex acenter w100 products">
                <img className="h300px" alt="productos" src="/images/bg-productos.webp"></img>
                <section className="pad-30">
                    <h2 className="cspica">Productos</h2>
                    <article className="flex col gap-10 justify">
                        <p>Las mejores marcas del sector han confiado en nuestra compañía para implantar sus soluciones en el mercado.</p>
                        <p>Consulte la selección de productos que podemos ofrecerle, clasificados por categorías y áreas de actividad.</p>
                        <Link to="/contacto" className="wine-button ">Consultar</Link>
                    </article>
                </section>
            </section> */}

            <section className="flex jscenter acenter vw70 pad-30 technology">
                <section>
                    <h2 className="cseneca">Tecnología Séneca</h2>
                    <section className="flex">
                        <section>
                            <p>Nuestro software está desarrollado para la completa gestión y publicación en internet de grabaciones y archivos multimedia. Además, facilita la comunicación entre las instituciones y el ciudadano que cubre las siguientes necesidades:</p>
                            <section className="flex row acenter gap-10 pad-10">
                                <i className="bi bi-camera-video-fill cseneca big-icon"></i>
                                <div className="flex gap-10 col pad-10">
                                    <h3 className="cseneca">Video-acta</h3>
                                    <label>Utiliza el audio o el vídeo como diario literal de las sesiones.</label>
                                </div>
                            </section>
                            <section className="flex row acenter gap-10 pad-10">
                                <i className="bi bi-mic-fill cseneca big-icon"></i>
                                <div className="flex gap-10 col pad-10">
                                    <h3 className="cseneca">Grabación y catalogación</h3>
                                    <label>Captura y catalogación de las sesiones de una manera sencilla.</label>
                                </div>
                            </section>
                            <section className="flex row acenter gap-10 pad-10">
                                <i className="bi bi-file-earmark-text cseneca big-icon"></i>
                                <div className="flex gap-10 col pad-10">
                                    <h3 className="cseneca">Transcripción de contenidos</h3>
                                    <label>Solución definitiva para los departamentos de publicaciones.</label>
                                </div>
                            </section>
                            <section className="flex row acenter gap-10 pad-10">
                                <i className="bi bi-cloud-fill cseneca big-icon"></i>
                                <div className="flex gap-10 col pad-10">
                                    <h3 className="cseneca">Mediateca online</h3>
                                    <label>Un portal web dinámico, organizado y ágil para la búsqueda y consulta.</label>
                                </div>
                            </section>
                        </section>
                    </section>
                </section>
                <img alt="Seneca" className="seneca-image" src="/images/seneca_main.webp"></img>
            </section>


            <section className="flex jcenter col acenter pad-30 clients">
                <h2 className="cspica">Nuestros clientes</h2>
                <section className="flex pad-10 wrap jcenter">
                    {clients.map(cl =>
                        <img key={cl.id} alt={cl.name} src={"/images/clients/" + cl.name}></img>
                    )}
                </section>
            </section>

            <section className="flex about-spica">
                <img className="h300px" alt="sobre-spica" src="/images/sobre-spica-bg.png"></img>
                <section className="flex pad-30 col acenter jcenter">
                    <img className="h60px" alt="spica-logo" src="/images/spicagris.webp"></img>
                    <p>Spica ha confiado en el progreso tecnológico desde su fundación y ha sabido superar con éxito, a través de más de 50 apasionantes años, los retos que el futuro le ha planteado. Las líneas de trabajo de la compañía se centran en el diseño, desarrollo e integración de sistemas audiovisuales con un alto valor añadido.</p>
                    <Link to="/nosotros" className="wine-button ">MÁS INFO</Link>
                </section>
            </section>


        </main>

    )
}

export default Main
